module.exports = __webpack_public_path__ + "img/bg_320.88d3b522.png";